import { render, staticRenderFns } from "./AccountRecharge.vue?vue&type=template&id=4ba2f7d5&scoped=true&"
import script from "./AccountRecharge.vue?vue&type=script&lang=js&"
export * from "./AccountRecharge.vue?vue&type=script&lang=js&"
import style0 from "./AccountRecharge.vue?vue&type=style&index=0&id=4ba2f7d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2f7d5",
  null
  
)

export default component.exports